export default __webpack_public_path__ + "static/2-ac556ec985d7c7dd76b17dce25a31c71.png";